import * as msal from "msal";

const isLocalhost = window.location.hostname === "localhost";
const currentUrl = window.location.origin;

const msalConfig = {
  auth: {
    clientId: "3f43a622-8015-4119-8cf9-ff427c1f6396",
    authority: "https://login.microsoftonline.com/3ef327d9-65e8-491d-b8d3-4aad2fa4c775",
    redirectUri: isLocalhost
      ? "http://localhost:3006/#/home"
      : "https://timesheet.cellereit.com.br/#/home",
    postLogoutRedirectUri: isLocalhost
      ? "http://localhost:3006/#/login"
      : "https://timesheet.cellereit.com.br/#/login",
    navigateToLoginRequestUrl: false, // Evitar redirecionamentos desnecessários
  },
  cache: {
    cacheLocation: "sessionStorage", // Usar sessionStorage para melhor segurança
    storeAuthStateInCookie: true, // Necessário para IE
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case msal.LogLevel.Error:
            console.error("MSAL:", message);
            break;
          case msal.LogLevel.Warning:
            console.warn("MSAL:", message);
            break;
          case msal.LogLevel.Info:
            console.info("MSAL:", message);
            break;
          case msal.LogLevel.Verbose:
            console.debug("MSAL:", message);
            break;
          default:
            console.log("MSAL:", message);
        }
      },
      piiLoggingEnabled: false,
    },
    windowHashTimeout: 60000, // Aumentar timeout para 60 segundos
    iframeHashTimeout: 6000,
    loadFrameTimeout: 6000,
  },
};

const msalInstance = new msal.UserAgentApplication(msalConfig);

// Configurar callback para lidar com redirects
msalInstance.handleRedirectCallback((error, response) => {
  if (error) {
    console.error("MSAL Redirect Error:", error);

    // Notificar a aplicação sobre o erro
    window.postMessage({
      type: 'MSAL_REDIRECT_ERROR',
      error: error
    }, currentUrl);
  } else if (response) {
    console.log("MSAL Redirect Success:", response);

    // Notificar a aplicação sobre o sucesso
    window.postMessage({
      type: 'MSAL_REDIRECT_SUCCESS',
      response: response
    }, currentUrl);
  }
});

// Configurar eventos para melhor debugging
msalInstance.setLogger(new msal.Logger(
  (level, message, containsPii) => {
    if (containsPii) return;

    switch (level) {
      case msal.LogLevel.Error:
        console.error("MSAL Logger:", message);
        break;
      case msal.LogLevel.Warning:
        console.warn("MSAL Logger:", message);
        break;
      case msal.LogLevel.Info:
        console.info("MSAL Logger:", message);
        break;
      case msal.LogLevel.Verbose:
        console.debug("MSAL Logger:", message);
        break;
      default:
        console.log("MSAL Logger:", message);
    }
  },
  {
    level: msal.LogLevel.Warning,
    piiLoggingEnabled: false,
  }
));

export default msalInstance;